import { render, staticRenderFns } from "./alHeader.vue?vue&type=template&id=6d9fc35d&scoped=true&"
import script from "./alHeader.vue?vue&type=script&lang=js&"
export * from "./alHeader.vue?vue&type=script&lang=js&"
import style0 from "./alHeader.vue?vue&type=style&index=0&id=6d9fc35d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9fc35d",
  null
  
)

export default component.exports